/* eslint-disable camelcase */
import styled, { css } from 'styled-components'

export interface BlockProps {
    isDark?: 'light' | 'dark'
    onClick?: () => void
    key?: string
    isRun?: boolean
    isPhase?: boolean
    countRuns?: number
    selected?: number
    className?: string
    style?: React.CSSProperties
    isStatusOperationFinished?: boolean
    noData?: boolean
}

export const Container = styled.div`
    display: flex;
    position: relative;
    padding: 16px 16px 0px;
`
export const WrapperContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const ItemRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 4px;
    position: relative;

    div {
        margin-right: 4px;
    }

    #tooltip-info > .tooltip-inner {
        background-color: red !important;
        border: 1px solid red;
    }
`
export const Item = styled.div`
    width: 100%;
    height: max-content;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 18px;
    position: relative;

    &:not(:last-child) {
        margin-right: 2px;
    }
`
export const Block = styled.div<BlockProps>`
    cursor: pointer;
    height: 8px;
    background: ${({ isStatusOperationFinished, noData }) =>
        noData ? 'var(--gray-400)' : isStatusOperationFinished ? '#1865A0' : '#75c3f0'};
    ${({ isRun, countRuns }) => {
        return !isRun && !countRuns
            ? css`
                  width: 100%;
                  flex: 1;
              `
            : isRun && countRuns > 0
            ? css`
                  width: calc(100% / ${countRuns} - ${countRuns - 1}px);
              `
            : css`
                  width: 100%;
                  flex: 1;
              `
    }}

    &:hover {
        opacity: 0.8;
    }

    &.selected {
        opacity: 0.8;
    }

    &.no-data {
        opacity: 0.8;
        cursor: initial;
    }
`
export const InnerContainer = styled.div`
    &,
    * {
        box-sizing: border-box;
    }
    width: 100%;
    position: relative;
    margin-top: 24px;
    display: flex;
    position: relative;

    .menu-left-side {
        position: absolute;
        left: 0;
        top: -12px;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 22px;

        span {
            font-style: normal;
            font-weight: 700 !important;
            font-size: 9px;
            line-height: 8px;
            text-align: center;
            letter-spacing: 0.1em;
            text-transform: uppercase;

            color: var(--gray-800);
        }
    }
`
